import { render, staticRenderFns } from "./OrdersByLocation.vue?vue&type=template&id=51275536"
import script from "./OrdersByLocation.vue?vue&type=script&lang=js"
export * from "./OrdersByLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports